// components/footer/data.ts

import { FacebookIcon } from "@/components/icons/FacebookIcon";
import { InstagramIcon } from "@/components/icons/InstagramIcon";
import { LinkedinIcon } from "@/components/icons/LinkedinIcon";
import { TiktokIcon } from "@/components/icons/TiktokIcon";
import { HELP_CENTER_FAQ_URL } from "@/constants/urls";

export interface FooterLink {
  title: string;
  link: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  state?: any;
}

export interface DataSection {
  title: string;
  text: string;
}

export interface EmailSection {
  title: string;
  titleDesktop: string;
  text: string;
  disclaimer: string;
}

export interface FormSection {
  text: string;
  placeholder: string;
}

export interface SocialItem {
  title: string;
  img: React.ElementType;
  link: string;
}

export interface OverallFooterData {
  copy: {
    text: string;
  };
  keep: DataSection;
  patent: DataSection;
  email: EmailSection;
  mobile: FooterLink[];
  wellness: FooterLink[];
  company: FooterLink[];
  policy: FooterLink[];
  form: FormSection;
  social: SocialItem[];
}

export const data: OverallFooterData = {
  copy: {
    text:
      "© " +
      new Date().getFullYear() +
      ` Nutraceutical Wellness Inc. All Rights Reserved.
      <br/>These statements have not been evaluated by the Food and Drug Administration.
      <br/>These products are not intended to diagnose, treat, cure, or prevent any disease.
      <br/>*${process.env.NEXT_PUBLIC_IQVIA_DATE}
      <br/>**Nutrafol’s calculation based in part on data reported by NIQ through its Omnisales Service for the Hair Growth Supplement category for the 52-week period ending 11/30/2024
      for the U.S. market according to Nutrafol’s custom product hierarchy. Copyright © 2025, Nielsen Consumer LLC.
      `,
  },
  keep: {
    title: "The #1 dermatologist-recommended hair growth supplement brand.*",
    text: "Nutrafol® is the best-selling hair growth supplement brand** built on a science-backed approach to whole-body wellness and hair health. Our products are clinically tested and physician-formulated to support different bio-specific needs during various life stages and lifestyles so that you can grow into the best version of yourself.",
  },
  patent: {
    title: "Our Patent",
    text: "Nutrafol® is a registered trademark of Nutraceutical Wellness, Inc. Synergen Complex® is a registered trademark of Nutraceutical Wellness Inc. <br/>U.S. Patent Nos. 11,213,478, 10,709,659 and 10,688,037.",
  },
  email: {
    title: "Stay in the thick of it with our newsletter.",
    titleDesktop: "Stay in the thick of it.",
    text: "Email address",
    disclaimer: "Get offers and updates sent directly to your inbox.",
  },
  mobile: [
    {
      title: "FAQ",
      link: HELP_CENTER_FAQ_URL,
    },
    {
      title: "CONTACT",
      link: "/our/brand/support/contact-us/",
    },
    {
      title: "PRESS",
      link: "/our/brand/about/press/",
    },
  ],
  wellness: [
    {
      title: "Shop Products",
      link: "/hair/brand/product/category/",
    },
    {
      title: "The Science",
      link: "/hair/brand/learn/science/",
    },
    {
      title: "Ingredients",
      link: "/hair/brand/learn/science/ingredients/",
    },
    {
      title: "Clinical Studies",
      link: "/hair/brand/learn/science/clinical-studies/",
    },
    {
      title: "Results",
      link: "/hair/brand/learn/results/customer-reviews/",
    },
    {
      title: "Find a Provider",
      link: "/hair/benefits/services/partners/find-a-partner/",
    },
    {
      title: "Blog",
      link: "/blog/",
    },
    {
      title: "FAQ",
      link: HELP_CENTER_FAQ_URL,
    },
  ],
  company: [
    {
      title: "Contact",
      link: "/our/brand/support/contact-us/",
    },
    {
      title: "Press",
      link: "/our/brand/about/press/",
    },
    {
      title: "Careers",
      link: "https://job-boards.greenhouse.io/nutrafol",
    },
    {
      title: "Our Story",
      link: "/our/brand/about/story/",
    },
    {
      title: "Our Service",
      link: "/hair/benefits/services/",
    },
    {
      title: "Become a Partner",
      link: "/hair/benefits/services/professionals/become-a-partner/",
    },
    {
      title: "Social Purpose",
      link: "/social-purpose/",
    },
    {
      title: "Nutrafol Academy",
      link: "/nutrafolacademy/",
    },
  ],
  policy: [
    {
      title: "Terms of Use",
      link: "/our/brand/support/legal/terms-of-use/",
    },
    {
      title: "Privacy Policy",
      link: "/our/brand/support/privacy-policy/",
    },
    {
      title: "Consumer Health Data Privacy Policy",
      link: "/consumer-health-data-privacy-policy/",
    },
    {
      title: "AdChoices - Do Not Sell or Share",
      link: "adchoices",
    },
    {
      title: "Do Not Sell or Share My Personal Information",
      link: "/our/brand/support/legal/privacy-request/",
    },
    {
      title: "Limit Use of My Sensitive Personal Information",
      link: "/our/brand/support/legal/privacy-request/?preselected=limit",
    },
    {
      title: "Sitemap",
      link: "/sitemap/",
    },
  ],
  form: {
    text: `Sign up to our mailing list and get $10 off your <span class="whitespace-nowrap">first subscription order.</span`,
    placeholder: "Your Email Address",
  },
  social: [
    {
      title: "instagram",
      img: InstagramIcon,
      link: "https://www.instagram.com/nutrafol/",
    },
    {
      title: "tiktok",
      img: TiktokIcon,
      link: "https://www.tiktok.com/@nutrafol",
    },
    {
      title: "facebook",
      img: FacebookIcon,
      link: "https://www.facebook.com/nutrafol/",
    },
    {
      title: "linkedin",
      img: LinkedinIcon,
      link: "https://www.linkedin.com/company/nutrafol/",
    },
  ],
};

export const menData: OverallFooterData = {
  ...data,
};
